import { APITaskDetailsModel } from "../Models/API/TaskModel"
import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"

export const useTaskDetails = (
    versionJobId?: string,
    taskID?: string
): FetchState<APITaskDetailsModel> =>
    useAppState(state => {
        if (
            versionJobId !== undefined &&
            taskID !== undefined &&
            state.api.tasks.details[versionJobId] !== undefined
        ) {
            return state.api.tasks.details[versionJobId][taskID]
        } else {
            return
        }
    })
